import { z } from 'zod';

export const compartmentShapeSchema = z.enum([
  'SQUARE_COMPARTMENT',
  'OVAL_COMPARTMENT',
  'PATHWAY',
  'BOTTOM_SQUARE_COMPARTMENT',
  'LEFT_SQUARE_COMPARTMENT',
  'RIGHT_SQUARE_COMPARTMENT',
  'TOP_SQUARE_COMPARTMENT',
]);
